import { User, UserManager } from 'oidc-client';
import * as Utils from "../utils/Config";

export class AuthService {
    userManager: UserManager;

    constructor() {
        const settings = {
            authority: Utils.MEN_IDENTITY_BASE_URL,
            client_id: Utils.REACT_APP_CLIENT_ID,
            redirect_uri: `${Utils.LIB_WEB_BASE_URL}/signin-callback.html`,
            post_logout_redirect_uri: Utils.LIB_WEB_BASE_URL,
            silent_redirect_uri: `${Utils.LIB_WEB_BASE_URL}/silent-renew.html`,
            response_type: "code",
            scope: "openid profile lib.backoffice.api lib.api men.api.user",
            automaticSilentRenew: false,
            accessTokenExpiringNotificationTime: 1000
           
        };
        this.userManager = new UserManager(settings);
    }

    public getUser(): Promise<User | null> {
        return this.userManager.getUser();
    }

    public login(): Promise<void> {
        return this.userManager.signinRedirect();
    }

    public renewToken(): Promise<User> {
        return this.userManager.signinSilent();
    }

    public logout(): Promise<void> {
        return this.userManager.signoutRedirect();
    }
}
